import { render, staticRenderFns } from "./CitationPageViewer.vue?vue&type=template&id=22291477&scoped=true&"
import script from "./CitationPageViewer.vue?vue&type=script&lang=js&"
export * from "./CitationPageViewer.vue?vue&type=script&lang=js&"
import style0 from "./CitationPageViewer.vue?vue&type=style&index=0&id=22291477&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22291477",
  null
  
)

export default component.exports